import { createBrowserHistory } from 'history';
//import ReactGA from 'react-ga';

const history = createBrowserHistory({ basename: '/areacliente' });

history.listen((location) => {
    let pagename = location.pathname.replace(/([a-z](?=[A-Z]))/g, '$1 ').replace('/','')
    document.title = pagename + ' - Área do Cliente';
    //ReactGA.set({ page: location.pathname });
    //ReactGA.pageview(location.pathname)
    //window.ga('set', 'page', location.pathname + location.search);
    //window.ga('send', 'pageview');

    window.gtag('config', 'G-3QG45Y0Q8K', {
        page_location: location.pathname
      })
      
  }
);

export default history;
